import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const fields = {
  _id: '',
  fiscalYear: '',
  orderNumber: '',
  appSection: '',
  description: '',
  subSection: '',
  generalLineAt: '',
  averageDailyAttendence: '',
  toUnitDescForAppro: '',
  motorVehicle: '',
  interestSplitPercent: '',
  isJt4Mill: '',
  isMtgTax: '',
  isMVTS: '',
  isMotorVehicleForfeiture: '',
  skipInterest: '',
  pageBreakBefore: '',
  details: {
    fundDescription: '',
    appFund: '',
    sharedFundAltKey: '',
    linkToMisc: '',
    remitTo: '',
    SDRType: '',
    isGeneralFund: '',
  },
};

export const taxUnit = {
  namespaced: true,
  state: () => ({
    regYears: {},
    maxFiscalYear: null,
  }),
  mutations: {
    setFiscalRegYears(state, regYears) {
      state.regYears = regYears;
    },
    setMaxFiscalYear(state, fiscalYear) {
      state.maxFiscalYear = fiscalYear;
    },
  },
  actions: {
    async loadTaxUnit({ commit, dispatch }, {
      criteria, baseCrudKey,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxUnit($criteria: taxUnitCriteriaType) {
            taxUnit(criteria: $criteria) {
                    ${fieldsToGqlString(fields)},
                  }
                }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data && results.data.taxUnit) {
          const unit = results.data ? results.data.taxUnit || [] : [];
          commit('base/crud/setItems', [baseCrudKey, unit], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem loading the Tax Unit list.', { root: true });
      }
    },
    async loadMaxFiscalYear({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query maxFyFromTaxUnit {
            maxFyFromTaxUnit
            }
          `,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data && results.data.maxFyFromTaxUnit) {
          commit('setMaxFiscalYear', results.data.maxFyFromTaxUnit);
          return results.data.maxFyFromTaxUnit;
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem fetching the maximum fiscal year.', { root: true });
      }
      return null;
    },
    async upsertTaxUnit({ dispatch, rootGetters, commit }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxUnit($item: taxUnitInputType!)  {
            upsertTaxUnit(upsert: $item) {
              ${fieldsToGqlString(fields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const taxFundStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newTaxUnit = results.data.upsertTaxUnit;
        const newList = mergeByIdNewAtTop(taxFundStateData || [], newTaxUnit);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Tax Unit', { root: true });
      }
    },
    async loadFiscalRegYears({ commit, dispatch }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
            taxUnitStatsFYRange { max, min },
          }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          commit('setFiscalRegYears', results.data.taxUnitStatsFYRange);
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting min/max Fiscal Year ranges.', { root: true });
      }
    },
    async validateTaxUnit({ dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query validateTaxUnit($criteria: taxUnitCriteriaType) {
              validateTaxUnit(criteria: $criteria) {
                isValid
                messages {
                  message,
                  values
                }
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results);
        if (results.data && results.data.validateTaxUnit) {
          return results.data.validateTaxUnit;
        }
        return { isValid: true, messages: [] };
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results);
        dispatch('flashError', 'There was a problem validating Tax Unit records.', { root: true });
        return { isValid: false, messages: [e.message || 'Unknown error'] };
      }
    },
  },
};

export default taxUnit;
